import React, { useEffect, useCallback } from "react";
import Layout from "../../Components/Layout";
import ProGrid from "../../Components/ProGrid/v2";
import NameCell from "../../Components/ProGrid/components/NameCell";
import { GET_ALL_RAPMGMT_LIST } from "../../../utils/services/apiPath";
import { postApi } from "../../../utils/services";
import usePageState from "../../../utils/customHooks/usePageState";
import { useSelector } from "react-redux";
import useColumn from "../../../utils/customHooks/useColumns";
import { rapMgmtPermissionSelector } from "../../store/features/permissions/permissionsSlice";
import { errorToast } from "../../../utils/toastHelper";
import { STAUTES } from "../../../utils/constant";

export default function RapMgmtList() {
  const {
    currentPage,
    pageSize,
    data: rapMgmt,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const { canView, canDelete, canExport } = useSelector(rapMgmtPermissionSelector);

  const getRedirectUrl = params => {
    return `/rap/${params?.row?.assignRAPInfoId}/RAPStatus`;
  };

  const columns = useColumn(
    [
      {
        field: "jobTitleName",
        headerName: "Approved Job Title",
        renderCell: params => <NameCell params={params} getRedirectUrl={getRedirectUrl} />
      },
      {
        field: "approvedJobTitle",
        headerName: "RAP Title"
      },
      {
        field: "category",
        headerName: "Category"
      },
      {
        field: "rapidCode",
        headerName: "RAPIDS Code"
      },
      {
        field: "onetCode",
        headerName: "ONetCode"
      }
    ],
    canDelete
  );

  const getRapMgmtList = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const payload = {
      pageIndex: searchString ? 1 : currentPage + 1,
      pageSize: pageSize,
      searchString: searchString,
      orderByAscending: true,
      orderCol: "jobTitleName",
      ...sortModel
    };
    const { data, totalRecords, error } = await postApi(GET_ALL_RAPMGMT_LIST, payload);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  useEffect(() => {
    getRapMgmtList();
  }, [getRapMgmtList]);

  return (
    <Layout canView={canView}>
      <ProGrid
        title="RAP Management"
        columns={columns}
        loading={status === STAUTES.LOADING}
        rows={rapMgmt}
        searchMode={!!searchString}
        searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
        hideAddButton={true}
        hideExport={!canExport}
        options={{
          getRowId: row => row.assignRAPInfoId,
          rowCount: rowCount,
          paginationMode: "server",
          paginationModel: { pageSize: pageSize, page: currentPage },
          onPaginationModelChange: setPagination,
          sortingMode: "server",
          onSortModelChange: setSortModel
        }}
      />
    </Layout>
  );
}
